<script>
  import colorScale from "@helpers/departmentTypeColorScale.js";

  export let item;
  export let onClick = null;
  export let hasBudget = false;

  export let wrapperClass = "";

  // Split the 'Services' value into a list of items
  $: responsibilities = item["Services"].split(",").map((d) => d.trim());

  // Get budget amount
  // MINOR FIXME: Put this directly in Sheet
  import departmentBudgets from "@data/departmentBudgets.json";

  const getBudget = (department) =>
    departmentBudgets?.find((d) => d.name == department)?.budget;

  import { format } from "d3-format";
  const suffixFormat = format(",.3s");
</script>

<button
  class={`card ${wrapperClass}`}
  on:click={() => {
    onClick && onClick(item);
  }}
>
  <img
    src="/images/departments/{item.Department}.png"
    alt="Department Icon"
    class="icon"
  />
  <div class="top">
    <h1>{item.Department}</h1>
    <p>
      <span
        class="type"
        style="background: {colorScale(item['Department Type'])}"
        >{item["Department Type"]}</span
      >
      {#if hasBudget}<span class="budget"
          >${suffixFormat(getBudget(item["Department"]))}</span
        >{/if}
    </p>
  </div>
  <div class="bottom">
    <ul>
      {#each responsibilities as responsibility}
        <li>{responsibility}</li>
      {/each}
    </ul>
  </div>
</button>

<style>
  .card {
    padding: 0.75rem;
    position: relative;
    background: white;
    /* box-shadow: -3px 3px 3px rgba(0, 0, 0, 0.25); */
    box-shadow: 0 0 0 3px var(--accent-color);
    /* border: 2px solid var(--accent-color); */
    text-align: left;
    /* margin: 0.25rem; */ /* Using grid-gap instead */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transition: opacity 500ms ease, box-shadow 200ms ease;
    cursor: pointer;
    user-select: none;
    -webkit-user-select: none; /* Chrome/Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+ */
    border-radius: 4px;
  }

  .icon {
    position: absolute;
    top: 0.75rem;
    right: 0.75rem;
    width: 20px;
    height: 20px;
  }

  .type {
    text-transform: uppercase;
    font-size: 0.7rem;
    font-weight: 600;
    color: white;
    display: inline-block;
    padding: 0.15rem 0.2rem 0.15rem 0.2rem;
  }

  .budget {
    color: black;
    display: inline-block;
    font-size: 0.85rem;
    vertical-align: middle;
    font-weight: 400;
  }

  h1 {
    font-size: 1.35rem;
    font-family: var(--font-serif);
    font-weight: 500;
    margin-bottom: 0.25rem;
    line-height: 1;
    color: var(--accent-color);
    text-transform: none;
    width: calc(100% - 0.75rem - 20px);
    /* border-bottom: 1px solid var(--accent-color); */
  }

  .top {
    margin-bottom: 1rem;
  }

  li {
    color: rgba(var(--text-color-rgb), 0.7);
    font-size: 0.85rem;
    font-weight: 300;
    margin-bottom: 0.25rem;
    text-transform: none;
    list-style-type: disc;
    list-style-position: inside;
  }

  .unselected {
    opacity: 0.9;
    /* border: 1px solid var(--accent-color); */
    box-shadow: 0 0 0 1px var(--accent-color);
  }

  .card:not(.unselectable):hover {
    opacity: 1;
  }

  .unselectable {
    cursor: not-allowed;
    opacity: 0.625;
  }

  /* On small screens, remove .bottom */
  @media screen and (max-width: 568px) {
    .card {
      flex-direction: column;
    }

    .top {
      margin-bottom: 0;
      display: flex;
      flex-direction: column;
      place-items: center;
      text-align: center;
      width: 100%;
    }

    h1 {
      margin-bottom: 0.5rem;
    }

    .bottom {
      display: none;
    }
  }

  .inTooltip {
    width: 100%;
  }
</style>
